import Raven from 'raven-js';
import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import { Metrics } from '../../utils/metrics';
import { getRequestErrorType } from '../../utils/getRequestErrorType';
import { jsx as _jsx } from "react/jsx-runtime";
export const ERROR_SEVERITY = {
  HIGH: 'HIGH',
  DEFAULT: 'DEFAULT'
};
const initialState = {
  hasError: false,
  error: null
};
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = initialState;
    this.resetErrorBoundary = () => {
      this.setState(initialState);
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, info) {
    const {
      errorBoundaryName,
      sentryOptions,
      metricsOptions,
      skipAutoSentryLogging,
      skipAutoMetricsLogging,
      onError
    } = this.props;
    if (!skipAutoSentryLogging) {
      Raven.captureException(error, Object.assign({}, sentryOptions, {
        extra: Object.assign({
          errorBoundaryName
        }, sentryOptions === null || sentryOptions === void 0 ? void 0 : sentryOptions.extra)
      }));
    }

    /* An aborted request means the page is already being torn down, so it is
     * not a failure anyone saw; counting it only buries real crashes. */
    const errorType = getRequestErrorType(error);

    // Metrics is undefined until setupMetricsFactory runs at app boot; in
    // tests that don't bootstrap, skip rather than throw inside a boundary.
    if (!skipAutoMetricsLogging && errorType !== 'aborted') {
      Metrics === null || Metrics === void 0 || Metrics.counter('error-boundary', Object.assign({
        errorBoundaryName,
        errorType
      }, metricsOptions)).increment();
    }
    onError === null || onError === void 0 || onError(error, info);
  }
  render() {
    const {
      children,
      FallbackComponent,
      severity,
      navMarkerName
    } = this.props;
    if (!this.state.hasError) return children;
    const fallback = /*#__PURE__*/_jsx(FallbackComponent, {
      error: this.state.error,
      resetErrorBoundary: this.resetErrorBoundary
    });
    if (severity === ERROR_SEVERITY.HIGH) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName || 'RHUMB_GLOBAL_ERROR',
        children: fallback
      });
    }
    return fallback;
  }
}